import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import './nonetwork.css'

export default function NoNetworkPage() {
  const intl = useIntl()

  return (
    <div className='no-network-container'>
      {/* Animated Background Waves */}
      <div className='ocean'>
        <div className='wave wave1'></div>
        <div className='wave wave2'></div>
        <div className='wave wave3'></div>
      </div>

      {/* Main Content */}
      <div className='no-network-content'>
        {/* Clouds */}
        <div className='cloud cloud-left'></div>
        <div className='cloud cloud-right'></div>

        {/* Main Illustration */}
        <div className='boat-container'>
          {/* Mast and Flag */}
          <div className='mast'>
            <div className='flag'></div>
          </div>

          {/* Person in Boat */}
          <div className='person-in-boat'>
            {/* Person */}
            <div className='person'>
              <div className='person-head'></div>
              <div className='person-body'></div>
              <div className='telescope'>
                <div className='telescope-body'></div>
                <div className='telescope-lens'></div>
              </div>
            </div>

            {/* Boat */}
            <div className='boat'>
              <div className='boat-body'></div>
            </div>
          </div>
        </div>

        {/* Error Badge */}
        <div className='error-badge'>
          <i className='bi bi-wifi-off me-2'></i>
          <FormattedMessage id='ERROR.NO_NETWORK' defaultMessage='NO NETWORK' />
        </div>

        {/* Main Message */}
        <h1 className='no-network-title'>
          <FormattedMessage id='ERROR.CONNECTION_LOST' defaultMessage='Connection Lost' />
        </h1>

        <p className='no-network-description'>
          <FormattedMessage
            id='ERROR.CHECK_INTERNET_CONNECTION'
            defaultMessage="We couldn't connect to the internet. Please check your connection and try again."
          />
        </p>

        {/* Retry Button */}
        <button
          className='retry-button'
          onClick={() => window.location.reload()}
        >
          <i className='bi bi-arrow-clockwise me-2'></i>
          <FormattedMessage id='MENU.RETRY' defaultMessage='Retry Connection' />
        </button>

        {/* Connection Status Indicator */}
        <div className='connection-status'>
          <div className='status-dot offline'></div>
          <span className='status-text'>
            <FormattedMessage id='STATUS.OFFLINE' defaultMessage='Offline' />
          </span>
        </div>
      </div>

      {/* Side Telescopes (Decorative) */}
      <div className='telescope-left'></div>
      <div className='telescope-right'></div>
    </div>
  )
}

